import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import {ShopTapBoxV2} from "../common/ShopTapBoxV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {useGetShopInfo1} from "../../../static/js/hock/shopHock";
import {
  formatAdminDelivery,
  formatText,
  handleImgError,
  openPopup
} from "../../../static/js/Common2";
import {formatStatus, telFormat, payTypeFormat} from "../../../static/js/service/formatService";
import {formatService} from "../../../static/js/service/userService";
import ShopInfo1PopupV22 from "./ShopInfo1PopupV22";
import {subNavEvent} from "../../../static/js/service/commonService";
import {feeTypeFormat} from "../../../utils/formatUtils";
import LogoSearchPopup from "../../popup/LogoSearchPopup";

export default function ShopInfo1V2() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [shopName, setShopName] = useState("");
  let [shopStatus, setShopStatus] = useState(0);
  let [serviceType, setServiceType] = useState(0);
  let [address, setAddress] = useState("");
  let [shopTel, setShopTel] = useState("");
  let [deliveryType, setDeliveryType] = useState(0);
  let [deliveryDoneMinutes, setDeliveryDoneMinutes] = useState(0);
  let [bundleDoneMinutes, setBundleDoneMinutes] = useState(0);
  let [intro, setIntro] = useState("");
  let [notice, setNotice] = useState("");
  let [logoImage, setLogoImage] = useState([]);
  let [noticeImage, setNoticeImage] = useState([]);
  let [category, setCategory] = useState([]);
  let [approvalTpcd1, setApprovalTpcd1] = useState();
  let [payTypeList, setPayTypeList] = useState([]);
  let [feeType, setFeeType] = useState(0);
  let [road, setRoad] = useState("");
  let [lat, setLat] = useState("");
  let [lng, setLng] = useState("");
  let [jibun, setJibun] = useState("");
  let [addressDetail, setAddressDetail] = useState("");
  let [deliverySettingType, setDeliverySettingType] = useState(1);
  let [isLogoChanged, setIsLogoChanged] = useState(false);

  useGetShopInfo1({
    setShopName, setShopStatus, setServiceType, setAddress,
    setShopTel, setDeliveryType, setDeliveryDoneMinutes,
    setBundleDoneMinutes, setIntro, setNotice,setNoticeImage,
    setLogoImage, setCategory, setPayTypeList, setApprovalTpcd1, setFeeType,
    setRoad, setLat, setLng, setJibun, setAddressDetail, setDeliverySettingType
  }, shopId);

  formatText(intro, "introText");
  formatText(notice, "noticeText");

  useEffect(() => {
    subNavEvent("shopNav", "shop1");
  }, []);

  if(logoImage.length > 0) {
    document.getElementById("shopLogoImg").setAttribute("data-id", logoImage[0].id);

    document.querySelectorAll(".logoPreview").forEach((element) => {
      element.setAttribute("src", logoImage[0].imageUrl);
      element.setAttribute("data-id", logoImage[0].id);
    })
  }
  if(noticeImage.length > 0) {
    for(let i = 0; noticeImage.length > i; i++) {
      if(i < 4) {
        document.querySelector(`.noticePreview${ i + 1 } input`).setAttribute("data-id", noticeImage[i].id);
        document.querySelector(`.imgRemoveBtn${ i + 1 }`).classList.remove("hide");
        document.querySelector(`.imgRemoveBtn${ i + 1 } img`).setAttribute("data-id", noticeImage[i].id);
        document.querySelector(`.noticePreview${ i + 1 } label img`).setAttribute("src", noticeImage[i].imageUrl);
      }
    }
  }

  let categoryText = "";
  if (category.length !== 0) {
    for (var i = 0; i < category.length; i++) {
      categoryText += category[i] + ', '
    }
    categoryText = categoryText.slice(0, -2)
  }

  let payTypeText = "";
  if (payTypeList.length !== 0) {
    for (var j = 0; j < payTypeList.length; j++) {
      payTypeText += payTypeFormat(payTypeList[j]) + ', '
    }
    payTypeText = payTypeText.slice(0, -2)
  }

  let shopInfo = {
    shopId: shopId,
    realName: shopName,
    prevShopStates: shopStatus,
    shopStatus: shopStatus,
    mobile: shopTel,
    deliCmplTm: deliveryDoneMinutes,
    wrapCmplTm: bundleDoneMinutes,
    shopInformation: intro,
    shopNotice: notice,
    shopLogo: logoImage,
    road: road,
    lat: lat,
    lng: lng,
    jibun: jibun,
    addressDetail: addressDetail
  }


  return (
    <main id="ShopInfo1V2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <ShopInfo1PopupV22 shopInfo={shopInfo} isLogoChanged={isLogoChanged} setIsLogoChanged={setIsLogoChanged} />
      <LogoSearchPopup setIsLogoChanged={setIsLogoChanged} />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 정보 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 정보 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/shopInfo1" setShopId={setShopId} setShopList={setShopList} />
              <ShopTapBoxV2 tap="tap1" shopId={shopId} />
            </div>
            {approvalTpcd1 === 4 &&
              <button
                id="shopModiBtn" type="button" className="openBtn commonBtn width90 ml-5"
                onClick={() => openPopup("shopInfo1Popup")}
              >
                수정하기
              </button>
            }

          </div>
          <div className="shopInfoBox">
            <table className="shopInfoTable">
              <thead></thead>
              <tbody>
              <tr>
                <th>로고</th>
                <td>
                  <img src="" alt="상점 로고" className="shopLogo logoPreview" onError={(e) => handleImgError(e)} />
                </td>
              </tr>
              <tr>
                <th>상점명</th>
                <th>{shopName}</th>
              </tr>
              <tr>
                <th>영업 상태</th>
                <td>
                  <span className={shopStatus === 6 ? "statusBox" : "statusBox redBox"}>{formatStatus(shopStatus)}</span>
                </td>
              </tr>
              <tr>
                <th>상점유형</th>
                <td>{formatService(serviceType)}</td>
              </tr>
              <tr>
                <th>카테고리</th>
                <td>
                  <p className="shopCategory">{categoryText}</p>
                </td>
              </tr>
              <tr>
                <th>상점 주소</th>
                <td>{address}</td>
              </tr>
              <tr>
                <th>상점 연락처</th>
                <td>{telFormat(shopTel)}</td>
              </tr>
              <tr>
                <th>배송방법</th>
                <td>{formatAdminDelivery(deliveryType)}</td>
              </tr>
              <tr>
                <th>배달비 설정 방법</th>
                <td>
                  <div className="d-flex a-center j-left">
                    <p className="mr-15">{deliverySettingType === 1 ? "거리별 추가 배달비" : "금액별 기본 배달비"}</p>
                    <span className="fs-12 fc-gray2">※변경이 필요할 경우 고객센터 1800-9991으로 문의주세요.</span>
                  </div>

                </td>
              </tr>
              <tr>
                <th>소요 예상시간</th>
                <td>
                  <span className="deliCmplTm">바로배달: {deliveryDoneMinutes}분</span>
                  <span className="cmplTmBar">|</span>
                  <span className="wrapCmplTm">방문포장: {bundleDoneMinutes}분</span>
                </td>
              </tr>
              <tr>
                <th>사용중인 결제수단</th>
                <td>{payTypeText}</td>
              </tr>
              <tr>
                <th>수수료 타입</th>
                <td>
                  <div className="d-flex a-center j-left">
                    {feeType !== 0 &&
                      <p className="mr-15">{feeTypeFormat(feeType)}</p>
                    }

                    <span className="fs-12 fc-gray2">※변경이 필요할 경우 고객센터 1800-9991으로 문의주세요.</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>상점 소개</th>
                <td id="introText"></td>
              </tr>
              <tr>
                <th>상점 공지</th>
                <td id="noticeText"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  )
}